import type { ActivationAlertsContractSocialAdFeedGroup } from "@similarweb/pro-api-client";

import { useApiQuery } from "app/modules/api-client";

import { useAlertsParams } from "../../../../../hooks/useAlertsParams";
import { useAdsAlertsQueryParams } from "../../../useAdsAlertsQueryParams";
import { AdPreviewSection } from "../AdPreviewSection";
import { AlertFallback } from "../AlertFallback";

import { SocialAdDetailsSection } from "./SocialAdDetailsSection";

type SocialAdContentProps = {
    group: ActivationAlertsContractSocialAdFeedGroup;
    selectedItemIndex: number;
    shouldFetchMoreAds: boolean;
};

export const SocialAdContent = ({ group, selectedItemIndex, shouldFetchMoreAds }: SocialAdContentProps) => {
    const { activationId } = useAlertsParams();
    const { platforms } = useAdsAlertsQueryParams();
    const { data, isError, refetch } = useApiQuery(
        {
            tag: "Alerts",
            methodName: "activationAlertsAdsSocialDomainDetail",
            options: {
                placeholderData: group,
                enabled: shouldFetchMoreAds,
            },
        },
        {
            domain: group.domain,
            activationId,
            platforms,
        },
    );

    const retry = () => {
        void refetch();
    };

    const currentAd = data?.ads[selectedItemIndex];

    if (!currentAd) {
        return (
            <AlertFallback
                isError={isError}
                retry={retry}
            />
        );
    }

    return (
        <>
            <AdPreviewSection imageUrl={currentAd.imageUrl} />
            <SocialAdDetailsSection ad={currentAd} />
        </>
    );
};
